import { stringify, ParsedUrlQuery } from 'querystring';

import { SearchQueryParams } from '../types/SearchQuery';
import filterParams from '../../common/utils/filterParams';

const API_LOCATION_SEO_ROUTE = '/api/v4/rutter/v1/search/seo/location/?';

type LocationSeoQueryParams = Pick<SearchQueryParams, 'category_slug' | 'location'>;

const ALLOWED_PARAMS: (keyof LocationSeoQueryParams)[] = [
  'category_slug',
  'location',
];

/**
 * Returns the location seo url for the specified query.
 * Unrecognized params will be removed.
 * The params are ordered alphabetically.
 */
const getLocationSeoUrl = (query: ParsedUrlQuery): string => API_LOCATION_SEO_ROUTE + stringify(
  filterParams<LocationSeoQueryParams>({
    query,
    allowedParams: ALLOWED_PARAMS,
    defaultParams: {},
  }),
);

export default getLocationSeoUrl;
